function SectionTitle(props: { children: any }) {
  const { children } = props;

  return <b className="text-primary-600">{children}</b>;
}

export default SectionTitle;
